import React, { useEffect } from 'react';
import { useStripe } from '@stripe/react-stripe-js';
import { LoadingComponent } from 'usbc-web-react-library';
import { useNavigate } from 'react-router-dom';
import { useLocation, matchPath } from 'react-router-dom';



const PaymentStatus = () => {
    let navigate = useNavigate();
    const stripe = useStripe();
    const location = useLocation();

    useEffect(() => {
        if (!stripe) {
            return;
        }

        // Retrieve the "payment_intent_client_secret" query parameter appended to
        // your return_url by Stripe.js
        const clientSecret = new URLSearchParams(window.location.search).get(
            'payment_intent_client_secret'
        );

        const lid = new URLSearchParams(window.location.search).get(
            'lid'
        );

        const season = new URLSearchParams(window.location.search).get(
            'season'
        );

        const slug = new URLSearchParams(window.location.search).get(
            'slug'
        );

        // Retrieve the PaymentIntent
        stripe
            .retrievePaymentIntent(clientSecret)
            .then(({ paymentIntent }) => {
                switch (paymentIntent.status) {
                    case 'succeeded':
                        navigate('/register/' + lid + '/' + season + '/' + slug + location.search + '&payment=1');
                        break;

                    case 'processing':
                        //  setMessage("Payment processing. We'll update you when payment is received.");
                        break

                    default:
                        navigate('/' + location.search + '&payment=0');
                        break;
                }
            });
    }, [stripe]);


    return (
        <LoadingComponent isLoading={() => true}
            description='Checking Payment'>
        </LoadingComponent>
    );
};

export default PaymentStatus;
